// @ts-nocheck
/**
 * BRINUTI — „KÉRJ ÚJ BORÍTÓMINTÁT” PANEL (2026-10-15)
 *
 * A jelölés: snippets/brinuti-borito-otlet.liquid. Bármelyik [data-bo-nyit]
 * gomb ugyanazt az alulról felcsúszó panelt nyitja (a láblécben van, egyszer).
 *
 * Beküldés: a Shopify saját kapcsolat-űrlapja, NATÍVAN (nem fetch-csel): a
 * Shopify spamszűrője (hCaptcha) csak a valódi elküldést engedi át — fetch-re
 * 400-at ad. Elküldés után a Shopify ugyanerre az oldalra hoz vissza
 * (?contact_posted=true): ilyenkor visszagörgetünk oda, ahol a vásárló járt,
 * és a „Megkaptuk” panelt mutatjuk.
 *
 * A mintakép a Teeinblue fotótárába megy (ugyanaz a feltöltő, amit a
 * kosár-előnézet is használ, brinuti-cro.js), a címe rejtett mezőként kerül
 * a levélbe — a Shopify kapcsolat-űrlapja fájlt nem fogad.
 *
 * Mérés (brinutiEsemeny → Clarity + dataLayer):
 *   borito_otlet_lathato · borito_otlet_nyit · borito_otlet_kuld · borito_otlet_elkuldve
 */
(function () {
  'use strict';
  if (window.__brinutiBoritoOtlet) return;
  window.__brinutiBoritoOtlet = true;

  /* Két mód: panel (a láblécből, minden oldalon) vagy a „Kérj borítót”
     oldal (/pages/kerj-boritot), ahol az űrlap a lapon van, panel nélkül. */
  var panel = document.querySelector('[data-bo-panel]');
  var hatter = document.querySelector('[data-bo-hatter]');
  var lapUrlap = document.querySelector('[data-bo-oldal-urlap]');
  var urlap = document.getElementById('BrinutiBoritoOtlet');
  if (!urlap || (!lapUrlap && (!panel || !hatter))) return;
  var doboz = lapUrlap || panel;

  var JELZES = 'brinuti_bo_kuldve';
  var BOLT = (window.Shopify && window.Shopify.shop) || 'nebnfj-ug.myshopify.com';
  var FELTOLTO = 'https://photo-api.teeinblue.com/api/merchant/shopify/upload-url?shop=' + BOLT;

  var urlapResz = doboz.querySelector('[data-bo-urlap-resz]');
  var keszResz = doboz.querySelector('[data-bo-kesz]');
  var otlet = urlap.querySelector('[data-bo-otlet]');
  var honnan = urlap.querySelector('[data-bo-honnan]');
  var oldal = urlap.querySelector('[data-bo-oldal]');
  var kepCim = urlap.querySelector('[data-bo-kepcim]');
  var kepMezo = urlap.querySelector('[data-bo-kep]');
  var kepFelirat = urlap.querySelector('[data-bo-kep-felirat]');
  var hiba = urlap.querySelector('[data-bo-hiba]');
  var kuldGomb = urlap.querySelector('[data-bo-kuld]');
  var kepToltodik = false;
  var aktualisHely = '';

  function esemeny(nev, hely) {
    try { if (window.brinutiEsemeny) window.brinutiEsemeny(nev, { brinuti_hely: hely || aktualisHely || '' }); } catch (e) { }
  }

  function tarolt(ertek) {
    try {
      if (ertek === undefined) return JSON.parse(sessionStorage.getItem(JELZES) || 'null');
      if (ertek === null) sessionStorage.removeItem(JELZES);
      else sessionStorage.setItem(JELZES, JSON.stringify(ertek));
    } catch (e) { }
    return null;
  }

  function tisztaCim() {
    var u = new URL(location.href);
    u.searchParams.delete('contact_posted');
    u.hash = '';
    return u.toString();
  }

  /* ---------- nyitás / zárás ---------- */

  /* A hCaptcha jelvénye (a Shopify spamszűrője) az űrlap első érintésekor
     jön be, és a panel bezárása után is ott ragadt a sarokban. Csak nyitott
     panelnél látszik (a beküldéshez kellhet), utána elrejtjük
     (brinuti-custom.css: html.bo-hcap-rejt). A Kapcsolat oldal saját
     űrlapját ez nem érinti: ott a jelzés soha nem kerül fel. */
  function hcapRejt(rejt) {
    document.documentElement.classList.toggle('bo-hcap-rejt', !!rejt);
  }

  function nyit(mutasdAKeszet) {
    urlapResz.hidden = !!mutasdAKeszet;
    keszResz.hidden = !mutasdAKeszet;
    if (lapUrlap) {
      /* az oldalon nincs mit kinyitni: odagörgetünk az űrlaphoz */
      lapUrlap.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (!mutasdAKeszet) setTimeout(function () { try { otlet.focus({ preventScroll: true }); } catch (e) { } }, 500);
      return;
    }
    hcapRejt(false);
    hatter.hidden = false;
    panel.hidden = false;
    document.documentElement.classList.add('bo-nyitva');
    requestAnimationFrame(function () {
      hatter.classList.add('bo-lathato');
      panel.classList.add('bo-lathato');
    });
    if (!mutasdAKeszet) setTimeout(function () { try { otlet.focus({ preventScroll: true }); } catch (e) { } }, 320);
  }

  function zar() {
    if (lapUrlap) return;
    hcapRejt(true);
    hatter.classList.remove('bo-lathato');
    panel.classList.remove('bo-lathato');
    document.documentElement.classList.remove('bo-nyitva');
    setTimeout(function () { hatter.hidden = true; panel.hidden = true; }, 260);
  }

  document.addEventListener('click', function (e) {
    var gomb = e.target.closest && e.target.closest('[data-bo-nyit]');
    if (gomb) {
      e.preventDefault();
      aktualisHely = gomb.getAttribute('data-bo-hely') || '';
      honnan.value = aktualisHely;
      oldal.value = tisztaCim();
      var elo = gomb.getAttribute('data-bo-elotolt');
      if (elo && !otlet.value.trim()) otlet.value = elo;
      hiba.hidden = true;
      esemeny('borito_otlet_nyit');
      nyit(false);
      return;
    }
    if (e.target.closest && e.target.closest('[data-bo-zar]')) { zar(); return; }
    if (hatter && e.target === hatter) zar();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel && !panel.hidden) zar();
  });

  /* Az oldalon az űrlap eleve látszik: a forrás a „Kérj borítót” oldal. */
  if (lapUrlap) {
    aktualisHely = 'Kérj borítót oldal';
    honnan.value = aktualisHely;
    oldal.value = tisztaCim();
  }

  /* ---------- mintakép ---------- */

  function kicsinyitve(fajl) {
    /* Telefonfotó 4–12 MB is lehet: 2000 px-re kicsinyítve töltjük fel. */
    return new Promise(function (kesz, hibaval) {
      var kep = new Image();
      var cim = URL.createObjectURL(fajl);
      kep.onload = function () {
        var arany = Math.min(1, 2000 / Math.max(kep.naturalWidth, kep.naturalHeight));
        var w = Math.max(1, Math.round(kep.naturalWidth * arany));
        var h = Math.max(1, Math.round(kep.naturalHeight * arany));
        var vaszon = document.createElement('canvas');
        vaszon.width = w; vaszon.height = h;
        var rajz = vaszon.getContext('2d');
        rajz.fillStyle = '#fff'; rajz.fillRect(0, 0, w, h);
        rajz.drawImage(kep, 0, 0, w, h);
        URL.revokeObjectURL(cim);
        vaszon.toBlob(function (blob) {
          if (blob) kesz({ blob: blob, w: w, h: h }); else hibaval(new Error('nem lett kép'));
        }, 'image/jpeg', 0.86);
      };
      kep.onerror = function () { URL.revokeObjectURL(cim); hibaval(new Error('nem olvasható kép')); };
      kep.src = cim;
    });
  }

  function feltolt(kep) {
    return fetch(FELTOLTO, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        filename: 'brinuti-otlet-' + Date.now().toString(36) + '.jpg',
        filesize: kep.blob.size, mimetype: 'image/jpeg', strategy: 'any', width: kep.w, height: kep.h
      })
    }).then(function (v) {
      if (!v.ok) throw new Error('feltöltési cím: ' + v.status);
      return v.json();
    }).then(function (v) {
      return fetch(v.signed_url, {
        method: 'PUT', body: kep.blob,
        headers: { 'Content-Type': 'image/jpeg', 'Cache-Control': 'public,max-age=31536000,immutable', 'x-amz-acl': 'public-read' }
      }).then(function (r) {
        if (!r.ok) throw new Error('feltöltés: ' + r.status);
        /* A tároló a feltöltő helyétől függ (we: Európa, ws: USA) — a
           nyilvános cím a feltöltési cím, a lekérdezési rész nélkül. */
        return String(v.signed_url).split('?')[0];
      });
    });
  }

  kepMezo.addEventListener('change', function () {
    var fajl = kepMezo.files && kepMezo.files[0];
    if (!fajl) return;
    kepToltodik = true;
    kepCim.value = '';
    kepFelirat.textContent = 'Kép feltöltése…';
    kicsinyitve(fajl).then(feltolt).then(function (cim) {
      kepCim.value = cim;
      kepFelirat.textContent = '✓ ' + (fajl.name || 'kép') + ' – feltöltve';
    }).catch(function () {
      kepFelirat.textContent = 'A képet nem sikerült feltölteni – küldd el nélküle, vagy próbáld újra';
    }).then(function () {
      kepToltodik = false;
      kepMezo.value = '';
    });
  });

  /* ---------- elküldés ---------- */

  /* Elfogó fázisban: a Shopify spamszűrője is a submit eseményre ül rá, de
     csak akkor engedjük tovább, ha minden rendben. */
  document.addEventListener('submit', function (e) {
    if (e.target !== urlap) return;
    if (kepToltodik) {
      e.preventDefault(); e.stopImmediatePropagation();
      hiba.textContent = 'Egy pillanat, még töltődik a kép…';
      hiba.hidden = false;
      return;
    }
    if (!otlet.value.trim()) {
      e.preventDefault(); e.stopImmediatePropagation();
      hiba.textContent = 'Írd meg röviden, milyen borítót szeretnél.';
      hiba.hidden = false;
      otlet.focus();
      return;
    }
    hiba.hidden = true;
    if (!oldal.value) oldal.value = tisztaCim();
    tarolt({ y: window.scrollY, hely: honnan.value, t: Date.now() });
    kuldGomb.textContent = 'Küldés…';
    esemeny('borito_otlet_kuld', honnan.value);
  }, true);

  /* ---------- visszatérés a beküldés után ---------- */

  (function visszaterve() {
    var j = tarolt();
    var friss = j && Date.now() - (j.t || 0) < 10 * 60000;
    var posted = /[?&]contact_posted=true/.test(location.search) || !!urlap.querySelector('[data-bo-sikeres]');
    var hibak = urlap.querySelector('[data-bo-hibak]');
    if (!friss) return;
    if (hibak) {
      tarolt(null);
      aktualisHely = j.hely || '';
      honnan.value = aktualisHely;
      hiba.textContent = (hibak.textContent || '').trim() || 'Valami nem sikerült, kérlek, ellenőrizd az e-mail címed.';
      hiba.hidden = false;
      if (j.y) window.scrollTo(0, j.y);
      nyit(false);
      return;
    }
    if (!posted) return;
    tarolt(null);
    aktualisHely = j.hely || '';
    try { history.replaceState(history.state, '', tisztaCim()); } catch (e) { }
    if (j.y) {
      window.scrollTo(0, j.y);
      /* a képek betöltése utána még tolhat az oldalon */
      setTimeout(function () { window.scrollTo(0, j.y); }, 400);
    }
    esemeny('borito_otlet_elkuldve');
    nyit(true);
  })();

  /* ---------- kollekció: kevés találatnál célzott szöveg ---------- */

  var kblokk = document.querySelector('[data-bo-kollekcio]');
  if (kblokk) {
    var kcim = kblokk.querySelector('[data-bo-kcim]');
    var kszoveg = kblokk.querySelector('[data-bo-kszoveg]');
    var alapCim = kcim.textContent;
    var alapSzoveg = kszoveg.textContent;
    var kevesSzoveg = 'Írd meg, és megtervezzük neked.';
    /* Egy sorban kell elférnie (CLAUDE.md, „Sortörés”): a kategóriát az
       „ilyen” szó jelzi, nem „ebben a kategóriában”. */
    var ilyen = kblokk.hasAttribute('data-bo-kategoriaban') ? 'ilyen ' : '';
    var m2szin = function () { var c = document.querySelector('.bsz__chip[aria-pressed="true"] .bsz__nev'); return c ? c.textContent.trim().toLowerCase() + ' ' : ''; };
    var igazit = function () {
      var db = document.querySelector('.bsz__db');
      var t = db && document.body.classList.contains('bsz-aktiv') ? (db.textContent || '').trim() : '';
      var m = t.match(/^(\d+) napló (.+) borítóval/);
      if (m && Number(m[1]) <= 4) {
        kcim.textContent = 'Csak ' + m[1] + ' ' + ilyen + m[2] + ' borítónk van';
        kszoveg.textContent = kevesSzoveg;
      } else if (/nincs napló/.test(t)) {
        kcim.textContent = 'Még nincs ilyen ' + m2szin(t) + 'borítónk';
        kszoveg.textContent = kevesSzoveg;
      } else {
        kcim.textContent = alapCim;
        kszoveg.textContent = alapSzoveg;
      }
    };
    var dbElem = document.querySelector('.bsz__db');
    if (dbElem) new MutationObserver(igazit).observe(dbElem, { childList: true, characterData: true, subtree: true });
    new MutationObserver(igazit).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    igazit();
  }

  /* ---------- láthatóság mérése (helyenként egyszer) ---------- */

  if ('IntersectionObserver' in window) {
    var lattuk = {};
    var io = new IntersectionObserver(function (bej) {
      bej.forEach(function (b) {
        if (!b.isIntersecting) return;
        var gomb = b.target.querySelector('[data-bo-nyit]');
        var hely = gomb ? (gomb.getAttribute('data-bo-hely') || '').split(':')[0] : '';
        io.unobserve(b.target);
        if (lattuk[hely]) return;
        lattuk[hely] = true;
        esemeny('borito_otlet_lathato', hely);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.bo-blokk, .bo-lablec').forEach(function (el) { io.observe(el); });
  }
})();
